<template>
    <template v-for="(value, key) in transportationItemList">
        <input name="trans" :value="value.id" :id="value.id" type="checkbox" v-model="selectedTransportationList" class="traffic">
        <label :for="key">{{value.name}}</label>
    </template>
</template>

<script>
    import { ref, onMounted, watchEffect } from 'vue'
    export default ({
        props: {
            master : {type: Object, require: true},
            condition : {type: Object, require: true},
        },
        setup (props, context) {
            const selectedTransportationList = ref(props.condition.selectedTransportation.value)
            const transportationItemList = JSON.parse(props.master.transportationItemList)
            let defaultTransportationList = props.condition.selectedTransportation.value

            // 監視の実装
            watchEffect(() => {
                if(props.condition.transportationAllCheck.value) {
                    let keyList = Object.keys(transportationItemList)
                    selectedTransportationList.value = keyList
                } else {
                    selectedTransportationList.value = defaultTransportationList
                }
            })

            watchEffect(() => {
                context.emit("transportation", selectedTransportationList);
            })

            // 完了時
            onMounted(() => {
                defaultTransportationList = []
            })

            return {
                transportationItemList,
                selectedTransportationList,
            }
        },
        emits: ['transportation']
    })
</script>